import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useCreateAttachmentForScreenReaderRenderer() {
  return useWebChatAPIContext().attachmentForScreenReaderRenderer;
}
